let partnersSlider = document.querySelector('.partners-slider')

if(partnersSlider) {
    new Swiper(partnersSlider, {
        slideClass: 'partner',
		loop: false,
		navigation: {
			nextEl: '.partnersSliderNext',
			prevEl: '.partnersSliderPrev',
		},
		speed: 600,
		slidesPerView: 2,
		breakpoints: {
            768: {
                slidesPerView: 4
            },
            1025: {
                slidesPerView: 6
            },
        }
    })
}